var path = 'visualizer/views/home.html';
var html = "<div> Visualizer Module - Home Page </div>";
window.angular.module('templates-visualizer').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;